import { retrieveLogs } from "./actions/log";
import { setCurrentSource } from "./actions/source-legacy";
import LogQuery from "./models/log-query";
import Source from "./models/source-legacy";
import { State } from "./reducers/";
import { Location } from "./utils/Location";

/**
 * There is a lot of imports and scripts in the top-level `index` file that makes is frustratingly hard
 * to unit test.  This file contains a set of methods that the `index` file can use which have been
 * separated out so they can be tested individually.
 */
export namespace IndexUtils {

    /**
     * @deprecated The method should not be use
     * This will return a promise which will retrieve the Sources from the store.  If there are
     * no stores from the Store, then it will attempt to retrieve them from the remote database.
     *
     * @param {Source[]} Collection of sources.  If they are empty, then the returning promise will retrieve
     *                      new sources from the web.
     */
    export function getAndSaveSources(root: Source[]): Promise<Source[]> {
        let realRoot = (root) ? root : [];
        return Promise.all(realRoot)
            .then(function (sources: Source[]) {
                if (sources && sources.length > 0) {
                    return sources;
                } else {
                    // TODO
                    return []
                }
            });
    }

    /**
     * Returns a promise that will search for a specific Source with the specified id.
     *
     * @param {Source[]} Collection of sources to filter through.
     * @param {string} SourceId to of the source to look for.
     */
    export function findSource(sources: Source[], sourceId: string): Promise<Source> {
        return getAndSaveSources(sources)
            .then(function (foundSources: Source[]) {
                let returnSource: Source;
                for (let source of foundSources) {
                    if (source && source.id === sourceId) {
                        returnSource = source;
                        break;
                    }
                }

                if (!returnSource) {
                    throw Error("Unable to find source with name.");
                }
                return returnSource;
            });
    }

    /**
     * Finds and stores all available sources than selects the one that has the selected sourceId.
     *
     * @param {Redux.Dispatch} The dispatch object ot send the new state.
     * @param {string} The source ID to search for.
     * @param {Source} The sources to search through. Can be undefined in which case they will be pulled form the server.
     */
    export function dispatchSelectedSourceSource(dispatch: any, sourceId: string, sources?: Source[], location?: Location): Promise<Source> {
        return findSource(sources, sourceId)
            .then(function (source: Source) {

                const today = new Date();
                const sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(today.getDate() - 7);

                const query = new LogQuery({
                    source: source,
                    startTime: sevenDaysAgo,
                    endTime: today,
                    limit: 50
                });
                dispatch(setCurrentSource(source));
                return source;
            });
    }

    /**
     * Dispatches the current selected source as "undefined".
     */
    export function removeSelectedSource(dispatch: any) {
        dispatch(setCurrentSource(undefined));
    };
}

export default IndexUtils;

class GlobalsArgs {
    _storeRef: any = undefined;

    get UserId() { return (this._storeRef?.getState() as State.All)?.context?.authUser?.id; }
    get OrganizationId() {
        return (this._storeRef.getState() as State.All)?.organization?.selectedOrganization?.id;
    }
    set store(value: any) { this._storeRef = value; }
}

export const BespokenSessionArgs = new GlobalsArgs();